<ng-container *ngIf="!loadingRow">
  <td class="no-padding" (click)="openInspection()" [@fadeIn]>
    <span class="eval {{getEval(inspection.Eval_)}}" style="height: 30px;width: 75px; margin-left: 40px; color: white;">{{inspection.Eval_}}</span>
  </td>
  <td (click)="openInspection()" [@fadeIn]>{{inspection.InspectionDate | date:'dd/MMM/yyyy'}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.Examiner">{{inspection.Examiner | truncate:[15]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.SerialNumber">{{inspection.SerialNumber | truncate:[15]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.UnitNumber">{{inspection.UnitNumber | truncate:[15]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.AddiUnitNumber">{{inspection.AddiUnitNumber | truncate:[15]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.CustomerName">{{inspection.CustomerName | truncate:[13]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.JobsiteName">{{inspection.JobsiteName | truncate:[15]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.Make">{{inspection.Make | truncate:[15]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.Model">{{inspection.Model | truncate:[15]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.Family">{{inspection.Family | truncate:[13]}}</td>
  
</ng-container>
<ng-container *ngIf="loadingRow">
  <td colspan="9">
    <div class="ph-item" style="height: 33px;">
      <div class="ph-row">
        <div class="ph-col-12"></div>
      </div>
    </div>
  </td>
</ng-container>
